module.exports = __webpack_public_path__ + "static/media/6820.88253b9e.jpg";